import React from "react";
import {
  Monitor,
  Theater,
  HeartPulse,
  Video,
  Snowflake,
  Palette,
  BookOpen,
  Bus,
  Users,
  GraduationCap,
  Music2,
  ClipboardList,
  Newspaper,
  School,
  Trophy,
  Phone,
  Camera,
  Activity,
  Mic2,
  FlaskConical,
  Drama,
  Leaf,
  Target,
  Telescope,
  Baby,
  Clock3,
  Mail,
  MapPin,
  Presentation,
} from "lucide-react";

/* Central icon registry — semantic key -> lucide-react component */
const ICONS = {
  monitor: Monitor,
  theater: Theater,
  "heart-pulse": HeartPulse,
  video: Video,
  snowflake: Snowflake,
  palette: Palette,
  "book-open": BookOpen,
  bus: Bus,
  users: Users,
  "graduation-cap": GraduationCap,
  music: Music2,
  clipboard: ClipboardList,
  newspaper: Newspaper,
  school: School,
  trophy: Trophy,
  phone: Phone,
  camera: Camera,
  activity: Activity,
  mic: Mic2,
  flask: FlaskConical,
  drama: Drama,
  leaf: Leaf,
  target: Target,
  telescope: Telescope,
  baby: Baby,
  clock: Clock3,
  mail: Mail,
  "map-pin": MapPin,
  teacher: Presentation,
};

const Icon = ({ name, size = 22, strokeWidth = 2, className, style }) => {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} style={style} />;
};

export default Icon;
